module.exports = __webpack_public_path__ + "img/antes_despues_338.6d0da0ff.png";